import { render, staticRenderFns } from "./StaticField.vue?vue&type=template&id=8dddb4f0&scoped=true"
import script from "./StaticField.vue?vue&type=script&lang=js"
export * from "./StaticField.vue?vue&type=script&lang=js"
import style0 from "./StaticField.vue?vue&type=style&index=0&id=8dddb4f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dddb4f0",
  null
  
)

export default component.exports